// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { dispatch } from '../index';
import { getArchiveLearners, getDeletedList, getLearners, inviteLearner as inviteLearnerApi } from 'api/learner';

// ----------------------------------------------------------------------

const defaultParams = {
    query: '',
    pageNo: 1,
    perPage: 20,
    sortBy: 'defaultSortOrder',
    sortDirection: 'DESC',
    quizType: 'lln',
    archiveFolder: ''
};

const initialState = {
    learners: [],
    params: defaultParams,
    learner: {},
    learnersCount: 0,
    resultType: 0,
    archiveFolder: '',
    isFetchingArchiveFolders: true,
    archiveFolders: [],
    isFetchingLearners: true
};

const slice = createSlice({
    name: 'learner',
    initialState,
    reducers: {
        // SET Learners
        setLearners(state, action) {
            const { data, isUpdateTotalCount } = action.payload;
            const { list = [], summary } = data;
            state.learners = list;

            // we will update the count
            if ((state.learnersCount === 0 || isUpdateTotalCount) && summary) {
                const { total = 0 } = summary;
                state.learnersCount = total;
            }
        },
        // SET Params
        setParams(state, action) {
            const { params, isResetParams = false } = action.payload;
            state.params = isResetParams ? defaultParams : params;
        },
        // SET Learner
        setLearner(state, action) {
            state.learner = action.payload;
        },
        // SET Result Type
        setResultType(state, action) {
            state.resultType = action.payload;
        },
        // SET Archive Folder
        setArchiveFolder(state, action) {
            state.archiveFolder = action.payload;
        },
        // SET is Fetching Archive Folders
        setIsFetchingArchiveFolders(state, action) {
            state.isFetchingArchiveFolders = action.payload;
        },
        // SET Archive Folders
        setArchiveFolders(state, action) {
            // state.archiveFolder = '';
            state.archiveFolders = action.payload;
        },
        // SET Is Fetcing Learners
        setIsFetchingLearners(state, action) {
            state.isFetchingLearners = action.payload;
        },
        // SET Learners Count
        setLearnersCount(state, action) {
            state.learnersCount = action.payload;
        }
    }
});

// eslint-disable-next-line prettier/prettier
export const {
    setLearners,
    setParams,
    setResultType,
    setArchiveFolder,
    setIsFetchingArchiveFolders,
    setArchiveFolders,
    setIsFetchingLearners,
    setLearnersCount
} = slice.actions;

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function fetchLearners(params, isUpdateTotalCount = false) {
    return async () => {
        try {
            const result = await getLearners(params);
            dispatch(
                slice.actions.setLearners({
                    data: result?.data || [],
                    isUpdateTotalCount
                })
            );
        } catch (error) {
            console.log('error', error);
            dispatch(
                slice.actions.setLearners({
                    data: []
                })
            );
        }
    };
}

export function fetchArchiveLearners(params, isUpdateTotalCount = false) {
    return async () => {
        try {
            const result = await getArchiveLearners(params);
            dispatch(
                slice.actions.setLearners({
                    data: result?.data || [],
                    isUpdateTotalCount
                })
            );
        } catch (error) {
            console.log('error', error);
            dispatch(
                slice.actions.setLearners({
                    data: []
                })
            );
        }
    };
}

export function fetchDeletedLearners(params, isUpdateTotalCount = false) {
    return async () => {
        try {
            const result = await getDeletedList(params);
            dispatch(
                slice.actions.setLearners({
                    data: result?.data || [],
                    isUpdateTotalCount
                })
            );
        } catch (error) {
            console.log('error', error);
            dispatch(
                slice.actions.setLearners({
                    data: []
                })
            );
        }
    };
}

export function setLearner(params) {
    return async () => {
        try {
            dispatch(slice.actions.setLearner(params || {}));
        } catch (error) {
            dispatch(slice.actions.setLearner({}));
        }
    };
}

export const inviteLearner = (learners) => {
    return async () => {
        try {
            // Assuming there's an API call to invite a learner
            const response = await inviteLearnerApi(learners);
            if (response.success) {
                return { success: true, message: 'Learner invited successfully.' };
            } else {
                return { success: false, message: response.message || 'Failed to invite learner.' };
            }
        } catch (error) {
            return { success: false, message: error.message || 'An error occurred while inviting the learner.' };
        }
    };
};
